// Single source of truth for the `mobile-view` breakpoint. Must match
// `screens['mobile-view']` in tailwind.config.ts (890px) — JS viewport checks
// that gate the same layouts as the CSS variant read this constant so the two
// can never drift (#5452: AppSidebar used 768 while the CSS flipped at 890,
// leaving 768–889px viewports with desktop rail behavior inside mobile CSS).
export const MOBILE_VIEW_BREAKPOINT_PX = 890;
